

import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Alert from 'vux/src/components/alert/index.vue'


export default {
components: {
Group,
Cell,
Alert,
},
provide(){
return{
reload:this.reload
}
},
data () {
return {
showJoinCompany:false,
model:{m_token:this.$route.query.token},
user:[],
company:[],
MC:0,
yun:0,
companys:"",
userServerReceive:"",
messageNumber:0,
u_img: require('../../assets/tx.png'),
isChange:true
}
},
created(){
this.login();
this.getMessageNumber();
},
methods: {
login:function(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getUserIndex',this.model,{emulateJSON:true}).then(function(res){

if(res.body.success)
{
if(res.body.headPortrait!="inexistence"){
this.u_img=res.body.headPortrait
}
this.user = res.body.user;
this.company = res.body.company;
this.yun = res.body.yun
this.MC = res.body.MC
this.companys = res.body.companys
if(this.company.certStatus != null && this.company.certStatus != undefined){
this.isChange = false;
}else{
this.isChange = true;
}
}else{
this.$vux.alert.show({
title: '提示',
content: res.body.message,
})
}
},function(res){
console.log(res.status);
});
},
goCollection(){
this.$router.push({path:'collection'});
},
goFoot(){
this.$router.push({path:'foot'});
},
goeditInfo(){
this.$router.push({path:'editInfo'});
},
addCompanyCode(){
let that =this;
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/addCompanyCode',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.$vux.alert.show({
title: '提示',
content: '加入成功',
onHide () {
that.$router.go(0);
}
})
}else{
this.$vux.alert.show({
title: '提示',
content: res.body.message,
})
}
},function(res){
console.log(res.status);
});
},
getMessageNumber(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/muserMessage/getMessageJoinEntityList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.messageNumber=res.body.rows.length;
}
},function(res){
console.log(res.status);
});
},
cert(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getIsCert',this.model,{emulateJSON:true}).then(function(res){
this.$router.push({
path : '/user/cert/cert1',
query : {'fromUrl':'userIndex'}
})

},function(res){
console.log(res.status);
});
},
goSubordinateCompany(){

window.location.href="/user/subordinateCompany";
}
}

}



// WEBPACK FOOTER //
// ./src/views/user/userIndex.vue